import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "./useWeb3";
import environment from "../utils/Environment";
import { insuranceContract } from "../utils/contractHelpers";
import axios from "axios";

export const ClaimInsurance = () => {
  const { account, chainId } = useWeb3React();
  const web3 = useWeb3();
  const insuranceAddress = environment.insurance;
  const contract = insuranceContract(insuranceAddress, web3);

  const claimInsurance = useCallback(
    async (insuranceIndexes, claimTokens) => {
      try {
        console.log("data >>>>> ", insuranceIndexes, "\n", claimTokens);

        var gasFunPrice;
        web3.eth.getGasPrice().then((result) => {
          var result2 = parseInt(result) + 3000000000;
          gasFunPrice = result2.toString();
        });
        const gas = await contract.methods
          .claimInsurance(insuranceIndexes, claimTokens)
          .estimateGas({ from: account });
        const gaslimit = gas + parseInt(15000);
        const claimed = await contract.methods
          .claimInsurance(insuranceIndexes, claimTokens)
          .send({ from: account, gas: gaslimit, gasPrice: gasFunPrice })
          .on("transactionHash", (tx) => {
            console.log("tx:::", tx);

            return tx;
          });
        // return true;
      } catch (e) {
        return e;
      }
    },
    [contract]
  );

  return { claimInsurance: claimInsurance };
};

export default ClaimInsurance;
